/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document.querySelector('custom-cart-drawer') ?? document,
  });

  const openHandler = async () => {
    /** @type {HTMLElement & {open?: () => void} | null} */
    const customDrawer = document.querySelector('custom-cart-drawer');
    /** @type {HTMLElement & {open?: () => void} | null} */
    const standardDrawer = document.querySelector('theme-drawer#cart-drawer');

    if (customDrawer && typeof customDrawer.open === 'function') {
      customDrawer.open();
    } else if (standardDrawer?.open) {
      standardDrawer.open();
    } else {
      window.location.href = Theme.routes?.cart_url || '/cart';
    }
  };

  if (actions.openCart) {
    actions.openCart.configure({ handler: openHandler });
  }
  if (actions.toggleCartDrawer) {
    actions.toggleCartDrawer.configure({ handler: openHandler });
  }
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
